var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription",
    transform: "translate(-276 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5330",
    "data-name": "Group 5330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 128,
    height: 128,
    transform: "translate(276 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(6154 -7314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M72.079,126.06h73.863a11.092,11.092,0,0,0,11.079-11.08V36.932H131.17A11.092,11.092,0,0,1,120.09,25.852V0H72.079A11.092,11.092,0,0,0,61,11.079v103.9A11.092,11.092,0,0,0,72.079,126.06Zm14.773-74.11H131.17a3.693,3.693,0,0,1,0,7.386H86.852a3.693,3.693,0,0,1,0-7.386Zm0,14.773H131.17a3.693,3.693,0,0,1,0,7.386H86.852a3.693,3.693,0,0,1,0-7.386Zm0,14.773H131.17a3.693,3.693,0,0,1,0,7.386H86.852a3.693,3.693,0,0,1,0-7.386Zm0,14.773H116.4a3.693,3.693,0,0,1,0,7.386H86.852a3.693,3.693,0,0,1,0-7.386Z",
    transform: "translate(-5923.01 7842.97)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M334.693,36.17h23.688L331,8.789V32.477A3.7,3.7,0,0,0,334.693,36.17Z",
    transform: "translate(-6126.533 7836.346)",
    fill: "#90205d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.a3a65a28.svg";
export { ForwardRef as ReactComponent };